import clsx from "clsx";
import { TextField } from "@material-ui/core";
import React from "react";

export function TextInput({
  classes,
  errors,
  value,
  handleChange,
  name,
  type,
  variant,
  disabled,
  selectOnFocus,
  inputProps,
  onFocusEvent,
  onKeyDownEvent,
  onPressEnterKeySearch,
  onBlurEvent,
  label = "",
  placeholder = "",
  multiline,
  rows = "",
}) {
  return (
    <TextField
      disabled={disabled}
      name={name}
      type={type}
      label={label}
      autoFocus={selectOnFocus}
      variant={variant || "outlined"}
      className={clsx(classes.tableFilterInput, classes.root)}
      helperText={(errors && errors[name]) || ""}
      error={errors && errors[name] ? true : false}
      value={value}
      multiline={multiline}
      minRows={rows}
      placeholder={placeholder}
      onChange={handleChange}
      InputLabelProps={{
        classes: {
          root: classes.tableInputLabel,
          focused: classes.tableInputFocused,
        },
      }}
      InputProps={{
        classes: {
          root: classes.tableInputOutlinedInput,
          focused: classes.tableInputFocused,
          notchedOutline: classes.tableNotchedOutline,
        },
        ...inputProps,
      }}
      onFocus={(event) => {
        if (selectOnFocus) {
          event.target.select();
        }
        if (onFocusEvent) {
          onFocusEvent();
        }
      }}
      onKeyDown={(event) => {
        if (onKeyDownEvent) {
          onKeyDownEvent();
        }
        if (onPressEnterKeySearch && event.key === "Enter") {
          onPressEnterKeySearch();
        }
      }}
      onBlur={(event) => {
        if (onBlurEvent) {
          onBlurEvent(event);
        }
      }}
    />
  );
}
